var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container404"},[_c('img',{attrs:{"src":require("@/assets/icon/404.png")}}),_c('p',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("回到首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }